export default {
  SCHOOLQUERY_BACKEND_URL: "https://mobile.webuntis.com/ms/schoolquery2", // Url zur Abfrage der Schulen vom MobileService
  SCHOOLQUERY_REQUEST_PREFIX: "wu_schulsuche-", // Prefix für Requests zur Abfrage von Schulen vom MobileService
  SCHOOLQUERY_DEBOUNCE_THRESHOLD_MS: 400, // Anzahl der Millisekunden, innerhalb derer kein neuer request zur schoolquery abgesetzt wird.
  MAX_SCHOOLS: 3, // Maximale Anzahl an besuchten Schulen, die gespeichert werden sollen
  UNTIS_URL: "https://www.untis.at", // Url zur Weiterleitung bei einem leeren Suchergebnis
};



// WEBPACK FOOTER //
// ./src/config/environment.js